/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Server_Errors_Noviewpermission2Inputs */

const he_server_errors_noviewpermission2 = /** @type {(inputs: Server_Errors_Noviewpermission2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין לך הרשאה לצפות בהגדרות הארגון`)
};

const en_server_errors_noviewpermission2 = /** @type {(inputs: Server_Errors_Noviewpermission2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to view this`)
};

/**
* | output |
* | --- |
* | "You do not have permission to view this" |
*
* @param {Server_Errors_Noviewpermission2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const server_errors_noviewpermission2 = /** @type {((inputs?: Server_Errors_Noviewpermission2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Server_Errors_Noviewpermission2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_server_errors_noviewpermission2(inputs)
	return en_server_errors_noviewpermission2(inputs)
});
export { server_errors_noviewpermission2 as "server_errors_noViewPermission" }